// Topaz kor Adobe Fonts (kit rxm2pyo) via typeKitStores i src/fonts/FontHandler.js,
// sa denna injectCss anropas aldrig. Behalls for att shopFont()-caset i switch.js
// kraver en modul, och for det fall butiken later till lokala fontfiler.

export default function loadCss() {
  return '';
}
